import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeople: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPeople"><Path d="M12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11C14.4853 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4853 2 12 2Z" fill="currentColor"/><Path d="M11.9996 12.5C7.38371 12.5 4.15432 15.9097 3.75289 20.1798L3.67578 21H20.3234L20.2463 20.1798C19.8449 15.9097 16.6155 12.5 11.9996 12.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeople;
